import * as _ from "lodash";
import * as crypto from "crypto-js";

const getDescryptedVal = (val, secretKey) => {
  let decryptObj = crypto.AES.decrypt(val, secretKey);
  return _.attempt(_.invoke, decryptObj, "toString", crypto.enc.Utf8);
};

export const removeSessionItem = (key) => {
  sessionStorage.removeItem(key);
};

export const getSessionItem = (key) => {
  let retrievedVal = sessionStorage.getItem(key);

  if (_.isNull(retrievedVal)) {
    return null;
  }
  let decryptedVal = getDescryptedVal(retrievedVal, key);

  if (_.isError(decryptedVal) || _.isEmpty(decryptedVal)) {
    removeSessionItem(key);
    return null;
  }

  let decryptedObj = _.attempt(JSON.parse.bind(null, decryptedVal));
  return _.isError(decryptedObj) ? decryptedVal : decryptedObj;
};

export const setSessionItem = (key, val) => {
  let parsedVal;

  if (_.isObject(val) || _.isArray(val)) {
    parsedVal = _.attempt(JSON.stringify.bind(null, val));
  } else if (_.isString(val)) {
    parsedVal = val;
  }

  if (!_.isError(parsedVal) && !_.isUndefined(parsedVal)) {
    parsedVal = crypto.AES.encrypt(parsedVal, key);
    sessionStorage.setItem(key, parsedVal);
  }
};
